import { RouterModule } from '@angular/router';
import { ClinicSelfReportConfigComponent } from './clinic-self-report-config.component';

export const ClinicSelfReportConfigRoutesModule = RouterModule.forChild([
    {
        path: '',
        component: ClinicSelfReportConfigComponent,
        data: {
            alias: 'self-report-config.index',
            reload: false
        }
    }
]);
